/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const analyticsOverviewSummaryDataSchema = z.object({
	totalCampaigns: z.number(),
	totalCandidates: z.number(),
	totalHires: z.number(),
	totalBudget: z.number(),
	avgBudgetPerCandidate: z.number().nullable(),
	avgPricePerHire: z.number().nullable(),
	totalViews: z.number(),
})

export type AnalyticsOverviewSummaryDataSchema = z.infer<typeof analyticsOverviewSummaryDataSchema>
